module.exports = __webpack_public_path__ + "static/media/2_desktop.defcc1fd.jpg";